// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Blurb.propTypes = {
  handleModal: PropTypes.func.isRequired,
};

// this are the details for this attestation field
export function Config() {
  return {
    name: 'txParentTaughtDriverEducationASC', // this used as the field name as well as the unique identifier
    productIds: [
      // 'a5c7735c-b0d9-4115-92fe-08dce3af17cb', // Texas Parent Taught Driver Education
      // '1efb9296-7240-4c5e-8954-6868421468eb', // Texas Parent Taught Driver Education + Texas Department of Public Safety Online Highway Sign and Traffic Law Exam
    ],
    errorMsg: `The Student must accept the <strong>Texas Parent Taught Driver Education enrollment contract</strong> by checking the box.`,
    onlyForBulk: false, // set to true if this attestation is only for bulk purchase
    type: 'checkbox', // iAgree, signature, checkbox
  };
}

// this is the blurb we display to tell the user what this attestation field is for
export function Blurb() {
  return (
    <>
      By checking this box, the Student accepts the{' '}
      <a
        href="https://cdn.certus.com/global/pdf/tx-ptde-enrollment-contract-asc.pdf"
        target="_blank"
        rel="noopener nofollow noreferrer"
      >
        Texas Parent Taught Driver Education enrollment contract
      </a>
      .
    </>
  );
}

// this is the explaination of the attestation, the full details of what the user is aggreeing to
export function ModalContent() {
  return null;
}
